<template>
  <modal title="" width="45" :showModal="showModal" @close-modal="closeModal">
    <div class="px-8 flex flex-col gap-4">
      <div class="flex justify-center">
        <img
          src="@/assets/images/booking-management/shipping-cart.png"
          alt="shipping cart"
        />
      </div>
      <div class="flex justify-center mt-4">
        <h1 class="text-2xl font-semibold">Add Receiver</h1>
      </div>
      <div class="mt-6 text-center">
        <label class="label">Who are you sending this shipments to?</label>
        <div class="d-flex justify-around mt-3 mb-4">
          <label class="radio-label" for="muleex-address">
            <input
              type="radio"
              id="muleex-address"
              value="previous"
              v-model="consignee"
            />
            Select previous Receiver
            <span></span>
          </label>
          <label class="radio-label ml-4" for="new-address">
            <input
              type="radio"
              id="new-address"
              value="new-consignee"
              v-model="consignee"
            />
            Add New Receiver
            <span></span>
          </label>
        </div>
      </div>
      <div class="mt-2">
        <label class="label">Select from customer's previous receiver</label>

        <div class="flex gap-4 items-center mt-3 mb-4">
          <div class="w-100">
            <!-- <label class="label"></label> -->
            <el-select
            :disabled="consignee == 'new-consignee'"
              v-model="selectedDeliveryLocationId"
              placeholder="Search Delivery Location"
            >
              <template v-if="deliveryLocations.length > 0" >
                <el-option
                  v-for="location in deliveryLocations"
                  :key="location.id"
                  :label="location.contactName"
                  :value="location.id"
                >
                </el-option>
              </template>
              <template v-else>
                <el-option>
                  <loader />
                </el-option>
              </template>
            </el-select>
          </div>
        </div>
      </div>

      <div class="flex items-center justify-center">
        <base-button text="Continue" @click="submit" />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      deliveryLocations: [],
      selectedDeliveryLocationId: "",
      consignee: "previous",
      newUser: false,
    };
  },
  computed: {
    consolidationId() {
      return this.$store.getters.getShipConsolidationID;
    },
  },
  methods: {
    disableButton() {
      // if(this.address.length > 0 && this.consigneeCount != "" && this.destinationType != "") {
      if (this.consignee.length > 0) {
        return false;
      }
      return true;
    },
    closeModal() {
      this.$emit("close-modal");
    },
    async getDeliveryLocations() {
      try {
        const response = await this.$_getDeliveryLocations();
        console.log(JSON.stringify(response, null, 2));
        this.deliveryLocations = response.data.data.locations;
      } catch (error) {
        this.handleError(error);
      }
    },
    submit() {
      if (this.consignee == "new-consignee") {
        this.closeModal();
        return;
      }
      this.loading = true;

      let selectedDeliveryLocation = this.deliveryLocations.find((location) => {
        return location.id == this.selectedDeliveryLocationId;
      });

      this.$emit("handleSubmit", selectedDeliveryLocation);
      this.closeModal();

      // console.log(JSON.stringify(selectedDeliveryLocation, null, 2))
      // let lastForm = 0;

      // if (selectedDeliveryLocation) {
      //   this.$store.dispatch("saveSelectedConsigneeLocation", selectedDeliveryLocation);
      //   this.handleDeliveryActions(selectedDeliveryLocation);
      //   lastForm = 2;
      // }
      // this.loading = false;
      // this.$store.dispatch("saveLastCompletedFormNo", lastForm);
    },
  },
  mounted() {
    this.getDeliveryLocations();
  },
};
</script>

<style scoped>
.button {
  background: #fcc210;
  color: var(--primaryblue);
  width: 40%;
  font-weight: 500;
  /* margin-top: 3rem; */
}

.new-address-button {
  text-decoration-line: underline;

  color: #da9601;
}

.radio-label span::after {
  background: #bec4d5;
}
</style>
